export class Header
{
	getContainer(): HTMLElement
	{
		return document.getElementById('header');
	}
}
